import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INSIGHTS } from "../lib/insights";

export default function InsightsPage() {
  return (
    <main data-testid="insights-page" className="pt-32">
      <section className="pb-16">
        <div className="container-myc max-w-4xl">
          <p className="eyebrow">Insights</p>
          <h1 className="h-display-1 text-[#2A0A0E] mt-6">
            Notes from our{" "}
            <span className="italic font-normal text-[#7A1F26]">
              research desk.
            </span>
          </h1>
          <p className="text-slate-600/65 mt-7 text-lg leading-relaxed max-w-2xl">
            Long-form perspectives on markets, taxation, NRI investing, and
            family wealth — written by our advisory team.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-myc">
          <div className="grid md:grid-cols-2 gap-px bg-slate-900/5 border border-slate-200/5">
            {INSIGHTS.map((p) => (
              <Link
                key={p.slug}
                to={`/insights/${p.slug}`}
                data-testid={`insight-card-${p.slug}`}
                className="bg-[#FAF5EB] hover:bg-[#FAF5EB] p-9 transition-all group"
              >
                <div className="flex items-center justify-between text-xs tracking-widest uppercase">
                  <span className="text-[#7A1F26]">{p.category}</span>
                  <span className="text-slate-600/40">{p.readTime}</span>
                </div>
                <h2 className="font-display text-2xl text-[#2A0A0E] mt-5 group-hover:text-[#7A1F26] transition-colors">
                  {p.title}
                </h2>
                <p className="text-slate-600/60 mt-4 leading-relaxed">
                  {p.excerpt}
                </p>
                <div className="mt-6 flex items-center justify-between text-sm text-slate-600/40">
                  <span>{p.date}</span>
                  <ArrowUpRight className="w-4 h-4 text-[#7A1F26] group-hover:rotate-45 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
